import React, { useEffect, useMemo, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppContext } from '../AppContext';
import { useCart } from '../CartContext';

const STORAGE_KEY = 'sf_cart_v1';

export default function OrderConfirmation() {
  const navigate = useNavigate();
  const { isLoggedIn } = useContext(AppContext);
  const { updateCart } = useCart();

  // Read useful params that Stripe often puts on the return URL
  const params = useMemo(() => new URLSearchParams(window.location.search), []);
  const paymentIntentId = params.get('payment_intent') || '';
  const redirectStatus  = params.get('redirect_status') || '';

  // Clear the local cart on success page (safe even if already cleared)
  useEffect(() => {
    try { localStorage.removeItem(STORAGE_KEY); } catch {}
    updateCart?.({ qty: 0, lines: [] });
  }, []);



  return (
    <div className="sf-confirm">
      <div className="sf-card">
        <div className="sf-icon">✅</div>
        <h1 className="sf-title">Order placed successfully</h1>
        <p className="sf-sub">
          Thanks for your purchase! We’ve received your order. We will update it's status in your My Orders page once it is shipped.
        </p>

        {!!paymentIntentId && (
          <div className="sf-meta">
            <div><span>Payment Intent:</span><code>{paymentIntentId}</code></div>
            {!!redirectStatus && <div><span>Status:</span><code>{redirectStatus}</code></div>}
          </div>
        )}

        <div className="sf-actions">
          <button className="sf-btn" onClick={() => navigate('/my-orders')}>View My Orders</button>
          <button className="sf-btn ghost" onClick={() => navigate('/shop')}>Back to Shop</button>
        </div>
      </div>

      <style>{`
:root{
  --sf-gold:#f5c65d;
  --sf-gold-10:rgba(245,198,93,.10);
  --sf-panel:#0b0b0b;
  --sf-bd:rgba(255,255,255,.12);
}
body { background:#000; color:#fff; font-family:'CustomFont',sans-serif; }
.sf-confirm{ min-height:calc(100vh - 120px); display:grid; align-items:start; justify-items:center; padding:24px 16px; }

.sf-card{
  width:100%; max-width:680px;
  background:var(--sf-panel); border:1px solid var(--sf-bd); border-radius:16px;
  padding:24px; text-align:center; box-shadow:0 10px 30px rgba(0,0,0,.4);
}
.sf-icon{ font-size:2.4rem; margin-bottom:8px; }
.sf-title{ font-size:1.8rem; font-weight:900; margin:0 0 6px; text-shadow:0 0 16px var(--sf-gold-10); }
.sf-sub{ opacity:.9; margin:0 0 16px; }
.sf-meta{
  background:rgba(255,255,255,.06); border:1px solid rgba(255,255,255,.14);
  border-radius:12px; padding:12px; text-align:left; margin:0 auto 14px; max-width:520px;
}
.sf-meta div{ display:flex; justify-content:space-between; gap:12px; padding:2px 0; }
.sf-meta span{ opacity:.9; }
.sf-meta code{ color:#fff; opacity:.95; }
.sf-actions{ display:flex; justify-content:center; gap:10px; margin-top:8px; flex-wrap:wrap; }
.sf-btn{
  padding:.75rem 1.1rem; border-radius:12px; font-weight:900; cursor:pointer;
  border:2px solid var(--sf-gold); background:var(--sf-gold); color:#000;
  box-shadow:0 6px 18px rgba(245,198,93,.26);
}
.sf-btn.ghost{
  background:transparent; color:var(--sf-gold); border:1px solid rgba(255,255,255,.25); box-shadow:none;
}
      `}</style>
    </div>
  );
}
